import { render, staticRenderFns } from "./getCodes.vue?vue&type=template&id=af90bdf6&scoped=true"
import script from "./getCodes.vue?vue&type=script&lang=js"
export * from "./getCodes.vue?vue&type=script&lang=js"
import style0 from "./getCodes.vue?vue&type=style&index=0&id=af90bdf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af90bdf6",
  null
  
)

export default component.exports